import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Send } from 'lucide-react';
import AskIfMark from './AskIfMark';

export default function AskIfComposer({ className = '' }: { className?: string }) {
  const navigate = useNavigate();
  const [input, setInput] = useState('');

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const message = input.trim();
    if (!message) return;
    navigate('/jarvis', { state: { message } });
  };

  return (
    <form
      onSubmit={submit}
      className={`flex items-center gap-3 rounded-2xl bg-navy py-2.5 pl-4 pr-1.5 shadow-sm ${className}`}
    >
      <AskIfMark
        size={26}
        showLabel
        tone="onDark"
        labelClassName="hidden sm:inline text-white font-semibold text-sm tracking-wide"
      />
      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="What's on your mind?"
        name="if-ask-home"
        autoComplete="off"
        autoCorrect="on"
        autoCapitalize="sentences"
        spellCheck
        data-lpignore="true"
        data-1p-ignore="true"
        className="flex-1 min-w-0 bg-transparent text-sm text-white placeholder-white/50 focus:outline-none"
      />
      <button
        type="submit"
        aria-label="Ask IF"
        className="p-2.5 pointer-coarse:p-3 rounded-xl bg-gold text-navy hover:bg-gold-light transition shrink-0 disabled:opacity-50"
        disabled={!input.trim()}
      >
        <Send size={16} />
      </button>
    </form>
  );
}
